/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { VersionableContentItemDto } from '../models';
import { VersionableContentTypeDto } from '../models';
import { VersionableContentTypeDtoPagedResponse } from '../models';
/**
 * VersionableContentTypeApi - axios parameter creator
 * @export
 */
export const VersionableContentTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [server] 
         * @param {string} [versionableContentTypeName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionableContentTypeContentsGet: async (server?: string, versionableContentTypeName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VersionableContentType/contents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (versionableContentTypeName !== undefined) {
                localVarQueryParameter['versionableContentTypeName'] = versionableContentTypeName;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [versionableContentTypeName] 
         * @param {string} [itemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionableContentTypeContentsItemGet: async (server?: string, versionableContentTypeName?: string, itemId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VersionableContentType/contents/item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (versionableContentTypeName !== undefined) {
                localVarQueryParameter['versionableContentTypeName'] = versionableContentTypeName;
            }

            if (itemId !== undefined) {
                localVarQueryParameter['itemId'] = itemId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VersionableContentItemDto} [body] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionableContentTypeContentsUpdatePost: async (body?: VersionableContentItemDto, server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VersionableContentType/contents/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VersionableContentTypeDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionableContentTypeCreatePut: async (body?: VersionableContentTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VersionableContentType/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionableContentTypeDeleteDelete: async (server?: string, name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VersionableContentType/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VersionableContentTypeDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionableContentTypeEditPost: async (body?: VersionableContentTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VersionableContentType/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionableContentTypeGetGet: async (server?: string, page?: number, itemsPerPage?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VersionableContentType/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VersionableContentTypeApi - functional programming interface
 * @export
 */
export const VersionableContentTypeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [server] 
         * @param {string} [versionableContentTypeName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeContentsGet(server?: string, versionableContentTypeName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<VersionableContentItemDto>>>> {
            const localVarAxiosArgs = await VersionableContentTypeApiAxiosParamCreator(configuration).apiVersionableContentTypeContentsGet(server, versionableContentTypeName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [versionableContentTypeName] 
         * @param {string} [itemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeContentsItemGet(server?: string, versionableContentTypeName?: string, itemId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<VersionableContentItemDto>>> {
            const localVarAxiosArgs = await VersionableContentTypeApiAxiosParamCreator(configuration).apiVersionableContentTypeContentsItemGet(server, versionableContentTypeName, itemId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {VersionableContentItemDto} [body] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeContentsUpdatePost(body?: VersionableContentItemDto, server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<VersionableContentItemDto>>> {
            const localVarAxiosArgs = await VersionableContentTypeApiAxiosParamCreator(configuration).apiVersionableContentTypeContentsUpdatePost(body, server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {VersionableContentTypeDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeCreatePut(body?: VersionableContentTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await VersionableContentTypeApiAxiosParamCreator(configuration).apiVersionableContentTypeCreatePut(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeDeleteDelete(server?: string, name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await VersionableContentTypeApiAxiosParamCreator(configuration).apiVersionableContentTypeDeleteDelete(server, name, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {VersionableContentTypeDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeEditPost(body?: VersionableContentTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await VersionableContentTypeApiAxiosParamCreator(configuration).apiVersionableContentTypeEditPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeGetGet(server?: string, page?: number, itemsPerPage?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<VersionableContentTypeDtoPagedResponse>>> {
            const localVarAxiosArgs = await VersionableContentTypeApiAxiosParamCreator(configuration).apiVersionableContentTypeGetGet(server, page, itemsPerPage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * VersionableContentTypeApi - factory interface
 * @export
 */
export const VersionableContentTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} [server] 
         * @param {string} [versionableContentTypeName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeContentsGet(server?: string, versionableContentTypeName?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<VersionableContentItemDto>>> {
            return VersionableContentTypeApiFp(configuration).apiVersionableContentTypeContentsGet(server, versionableContentTypeName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [versionableContentTypeName] 
         * @param {string} [itemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeContentsItemGet(server?: string, versionableContentTypeName?: string, itemId?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<VersionableContentItemDto>> {
            return VersionableContentTypeApiFp(configuration).apiVersionableContentTypeContentsItemGet(server, versionableContentTypeName, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VersionableContentItemDto} [body] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeContentsUpdatePost(body?: VersionableContentItemDto, server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<VersionableContentItemDto>> {
            return VersionableContentTypeApiFp(configuration).apiVersionableContentTypeContentsUpdatePost(body, server, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VersionableContentTypeDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeCreatePut(body?: VersionableContentTypeDto, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return VersionableContentTypeApiFp(configuration).apiVersionableContentTypeCreatePut(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeDeleteDelete(server?: string, name?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return VersionableContentTypeApiFp(configuration).apiVersionableContentTypeDeleteDelete(server, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VersionableContentTypeDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeEditPost(body?: VersionableContentTypeDto, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return VersionableContentTypeApiFp(configuration).apiVersionableContentTypeEditPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionableContentTypeGetGet(server?: string, page?: number, itemsPerPage?: number, options?: AxiosRequestConfig): Promise<AxiosResponse<VersionableContentTypeDtoPagedResponse>> {
            return VersionableContentTypeApiFp(configuration).apiVersionableContentTypeGetGet(server, page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VersionableContentTypeApi - object-oriented interface
 * @export
 * @class VersionableContentTypeApi
 * @extends {BaseAPI}
 */
export class VersionableContentTypeApi extends BaseAPI {
    /**
     * 
     * @param {string} [server] 
     * @param {string} [versionableContentTypeName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionableContentTypeApi
     */
    public async apiVersionableContentTypeContentsGet(server?: string, versionableContentTypeName?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<VersionableContentItemDto>>> {
        return VersionableContentTypeApiFp(this.configuration).apiVersionableContentTypeContentsGet(server, versionableContentTypeName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {string} [versionableContentTypeName] 
     * @param {string} [itemId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionableContentTypeApi
     */
    public async apiVersionableContentTypeContentsItemGet(server?: string, versionableContentTypeName?: string, itemId?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<VersionableContentItemDto>> {
        return VersionableContentTypeApiFp(this.configuration).apiVersionableContentTypeContentsItemGet(server, versionableContentTypeName, itemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {VersionableContentItemDto} [body] 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionableContentTypeApi
     */
    public async apiVersionableContentTypeContentsUpdatePost(body?: VersionableContentItemDto, server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<VersionableContentItemDto>> {
        return VersionableContentTypeApiFp(this.configuration).apiVersionableContentTypeContentsUpdatePost(body, server, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {VersionableContentTypeDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionableContentTypeApi
     */
    public async apiVersionableContentTypeCreatePut(body?: VersionableContentTypeDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return VersionableContentTypeApiFp(this.configuration).apiVersionableContentTypeCreatePut(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionableContentTypeApi
     */
    public async apiVersionableContentTypeDeleteDelete(server?: string, name?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return VersionableContentTypeApiFp(this.configuration).apiVersionableContentTypeDeleteDelete(server, name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {VersionableContentTypeDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionableContentTypeApi
     */
    public async apiVersionableContentTypeEditPost(body?: VersionableContentTypeDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return VersionableContentTypeApiFp(this.configuration).apiVersionableContentTypeEditPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {number} [page] 
     * @param {number} [itemsPerPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionableContentTypeApi
     */
    public async apiVersionableContentTypeGetGet(server?: string, page?: number, itemsPerPage?: number, options?: AxiosRequestConfig) : Promise<AxiosResponse<VersionableContentTypeDtoPagedResponse>> {
        return VersionableContentTypeApiFp(this.configuration).apiVersionableContentTypeGetGet(server, page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
}
